import { Input } from 'antd'
import styled from 'styled-components'

const StyledFlexInputGroup = styled(Input.Group)`
  display: flex !important;
`

export default StyledFlexInputGroup
